// extracted by mini-css-extract-plugin
export default {"userStats":"style_userStats__KGUCk","img":"style_img__PCBV1","stats":"style_stats__FQGAo"};